import { IDeviceSize } from '@checkout/device';
import { IItem } from '@checkout/items';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { SlideDown } from 'react-slidedown';
import { compose } from 'redux';
import { ProductItem } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { IIMobileVisibleItemsConfig } from './../../../config/contextCheckoutConfig.d';
import messages from './../../../i18n/base-en';
import { addLineItemRequest, removeLineItemRequest } from './../../../reducers/checkout';
import { Button } from './../../presentational';
import * as Styles from './ProductsList.scss';

interface IOwnProps {
  items: IItem[];
  readOnly?: boolean;
  giftWrapProductId?: string;
  deviceSize?: IDeviceSize;
  initialMobileVisibleItems?: IIMobileVisibleItemsConfig;
  withThumbnails?: boolean;
}

interface IConnectedProps {
  isLineItemFetching: boolean;
}

interface IConnectetDispatchProps {
  increaseQuantity: typeof addLineItemRequest;
  decreaseQuantity: typeof removeLineItemRequest;
}

type Props = IOwnProps & IConnectetDispatchProps & IConnectedProps & InjectedIntlProps;

interface IOwnState {
  isExpanded: boolean;
  visibleProductItems: IItem[];
}

class ProductsList extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isExpanded: false,
    visibleProductItems: [],
  };

  componentWillMount() {
    this.setVisibleProductItems();
  }

  componentDidUpdate(prevProps: IOwnProps) {
    if ((prevProps.deviceSize && prevProps.deviceSize.sm) !== (this.props.deviceSize && this.props.deviceSize.sm) ||
        (prevProps.deviceSize && prevProps.deviceSize.md) !== (this.props.deviceSize && this.props.deviceSize.md) ||
        (prevProps.items !== this.props.items)) {

      this.setVisibleProductItems();
    }
  }

  toggleExpand = () => {
    this.setState({
      isExpanded: !this.state.isExpanded,
    }, () => {
      this.setVisibleProductItems();
    });
  }

  setVisibleProductItems = () => {
    const { items, deviceSize, initialMobileVisibleItems } = this.props;
    let productItems = items;

    if (initialMobileVisibleItems) {
      if (deviceSize && deviceSize.sm && initialMobileVisibleItems.onSmallMobile < items.length) {
        productItems = items.slice(0, initialMobileVisibleItems.onSmallMobile + 1);
      } else if (deviceSize && deviceSize.md && initialMobileVisibleItems.onMediumMobile < items.length) {
        productItems = items.slice(0, initialMobileVisibleItems.onMediumMobile + 1);
      }
    }

    this.setState({
      visibleProductItems: this.state.isExpanded ? this.props.items : productItems,
    });
  }

  isLoadLessVisible = () => {
    const { deviceSize, initialMobileVisibleItems } = this.props;
    const { visibleProductItems, isExpanded } = this.state;
    let isVisible = false;

    if (initialMobileVisibleItems && isExpanded) {
      if (deviceSize && deviceSize.sm) {
        isVisible = initialMobileVisibleItems.onSmallMobile < visibleProductItems.length - 1;
      } else if (deviceSize && deviceSize.md) {
        isVisible = initialMobileVisibleItems.onMediumMobile < visibleProductItems.length - 1;
      }
    }

    return isVisible;
  }

  render() {
    const {
      intl,
      items,
      increaseQuantity: increase,
      decreaseQuantity: decrease,
      readOnly,
      giftWrapProductId,
      isLineItemFetching,
      deviceSize,
      initialMobileVisibleItems,
      withThumbnails } = this.props;
    const { formatMessage } = intl;
    const { isExpanded, visibleProductItems } = this.state;
    const isLessMoreVisible = this.isLoadLessVisible();

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.list}>
            {visibleProductItems && visibleProductItems.length > 0 && (
              <SlideDown className={initialMobileVisibleItems ? 'slidedown' : ''} transitionOnAppear={false}>
                {visibleProductItems.map((item, index) => {
                  const isLast = index === visibleProductItems.length - 1;
                  const isLoadMoreVisible = !isExpanded && isLast && deviceSize && deviceSize.md && visibleProductItems.length < items.length;

                  return (
                    <ProductItem
                      key={item.item}
                      isLoadMoreVisible={isLoadMoreVisible}
                      onLoadMoreItems={this.toggleExpand}
                      loadMoreButtonLabel={formatMessage(messages.show_more_products_button_label, { itemsLength: items.length })}
                      isGiftWrapProduct={item.item === giftWrapProductId}
                      urlPrefix={checkoutContextConfig.ui.productItem.productUrlPrefix}
                      item={item}
                      increaseQuantity={increase}
                      decreaseQuantity={decrease}
                      readOnly={readOnly}
                      withThumbnails={withThumbnails}
                      isFetching={isLineItemFetching}
                    />
                  );
                })}
                {isLessMoreVisible && (
                  <div className={Styles.loadLessButton}>
                    <Button
                      type="button"
                      variant="clear"
                      size="medium"
                      onClick={this.toggleExpand}
                      label={formatMessage(messages.show_less_products_button_label)}
                    />
                  </div>
                )}
              </SlideDown>
            )}
          </div>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isLineItemFetching: state.checkout.isLineItemFetching,
    }),
    {
      increaseQuantity: addLineItemRequest,
      decreaseQuantity: removeLineItemRequest,
    },
  )
)(ProductsList);
